import React, {Component} from "react"
import {injectIntl} from "react-intl"

import ErrorAlert from './ErrorAlert'
import Alert from './Alert'
import Spinner from './Spinner'

import BirthMonthPicker from "./BirthMonthPicker"
import Form from "./form/Form"
import CountrySelect from "./form/CountrySelect"
import EducationSelect from "./form/EducationSelect"
import {Input, RadioGroup} from "formsy-react-components"
import {format} from "../util/DateUtil"
import {PASSWORD_MIN_LENGTH} from "../constants"

const defaultConfig = {
  emailAddress:{
    readOnly: true
  },
  password: {
    required: false
  },
  accountLocked:{
    disabled: true,
    hidden: false
  },
  enterpriseReference:{
    hidden: true
  }
}

class UserForm extends Component {

  constructor(data) {
    super(data)

    this.state = {
      disabled: true
    }

    this.submit = this.submit.bind(this)
  }

  componentDidMount() {
    if(this.props.onRef)
      this.props.onRef(this)
  }
  componentWillUnmount() {
    if(this.props.onRef)
      this.props.onRef(undefined)
  }

  submit(){
    this.form.submit()
  }

  enableSubmitButton = () => {
    this.setState({
      disabled: false
    });
  }

  disableSubmitButton = () => {
    this.setState({
      disabled: true
    });
  }

  render() {
    const formatMessage = this.props.intl.formatMessage

    const user = this.props.user

    const inputStyle = this.props.inputStyle || {}

    const config = Object.assign({}, defaultConfig, this.props.config)

    return (
      <Form
        onSubmit={this.props.onSubmit}
        onValid={()=>{
          if(this.props.onValid) this.props.onValid()
          this.enableSubmitButton()
        }}
        onInvalid={()=>{
          if(this.props.onInvalid) this.props.onInvalid()
          this.disableSubmitButton()
        }}
        validatePristine={false}
        onRef={(form)=>{this.form = form}}>


        {config.enterpriseReference.hidden?
          ""
          :
          <div className="form-group">
            <Input
              name="enterpriseReference"
              value={user.enterpriseReference || ''}
              label={formatMessage({id: 'input.label.enterpriseReference'})}
              type="text"
              placeholder={formatMessage({id: 'input.placeholder.enterpriseReference'})}
              {...inputStyle}
            />
          </div>
        }


        <div className="form-group">
          <Input
            name="name"
            value={user.name}
            label={formatMessage({id: 'input.label.name'})}
            type="text"
            placeholder={formatMessage({id: 'input.placeholder.name'})}
            {...inputStyle}
          />
        </div>
        <div className="form-group">
          <Input
            name="emailAddress"
            value={user.emailAddress}
            label={formatMessage({id: 'input.label.email'})}
            type="email"
            placeholder={formatMessage({id: 'input.placeholder.email'})}
            validations="isEmail"
            validationErrors={{
              isEmail: formatMessage({id: 'input.error.email'})
            }}
            {...inputStyle}
            readOnly={config.emailAddress.readOnly}
            required={config.emailAddress.required}
          />
        </div>

        <div className="form-group">
          <Input
            name="password"
            value=""
            type="password"
            label={formatMessage({id: 'input.label.password'})}
            placeholder={formatMessage({id: 'input.placeholder.password'})}
            validations="minLength:8"
            validationError={formatMessage({id:"input.error.password.minLength"}, {length:PASSWORD_MIN_LENGTH})}
            {...inputStyle}
            required={config.password.required}
          />
        </div>
        <div className="form-group">
          <Input
            name="repassword"
            type="password"
            value=""
            label={formatMessage({id: 'input.label.repassword'})}
            validations="equalsField:password"
            validationErrors={{
              equalsField: formatMessage({id: 'input.error.repassword'})
            }}
            placeholder={formatMessage({id: 'input.placeholder.repassword'})}
            {...inputStyle}
            required={config.password.required}
          />
        </div>

        {config.accountLocked.hidden?
          ""
          :
          <div className="form-group radio">
            <RadioGroup
              name="accountLocked"
              type="inline"
              label="Account Locked"
              value={`${user.accountLocked}`}
              {...inputStyle}
              disabled={config.accountLocked.disabled}
              options={
                [
                  {value: 'true', label: 'True'},
                  {value: 'false', label: 'False'}
                ]
              }

            />
          </div>
        }

        <div className="form-group radio">
          <RadioGroup
            name="isMale"
            type="inline"
            label={formatMessage({id: 'input.label.gender'})}
            value={`${user.isMale}`}
            {...inputStyle}
            options={
              [
                {value: 'true', label: formatMessage({id: 'male'})},
                {value: 'false', label: formatMessage({id: 'female'})}
              ]
            }

          />
        </div>

        <div className="form-group row">
          <label className="control-label col-sm-3">
            {formatMessage({id: 'input.label.dob'})}
          </label>
          <div className="col-sm-9">
            <BirthMonthPicker
              name="dob"
              value={user.dob}
              onChange={(newValue) => {
                // user.dob = newValue
              }}
            />
          </div>
        </div>
        <div className="form-group">
          <CountrySelect
            name="country"
            value={user.country}
            {...inputStyle}
          />
        </div>

        <div className="form-group">
          <EducationSelect
            name="education"
            value={user.education}
            {...inputStyle}
          />
        </div>

        {
          config.submit.hidden?
            ''
            :
            <div className="form-group" style={{'textAlign': 'right'}}>
              <div className="col-sm-4 col-sm-offset-8">
                <Spinner show={user.loading}/>
                <ErrorAlert error={user.error}/>
                <Alert show={user.message} message={user.message ? user.message : ""} level="info"/>
                <input className="btn btn-primary"
                       formNoValidate={false} type="submit"
                       disabled={this.state.disabled || user.loading}
                       defaultValue={formatMessage({id: 'button.save.changes'})}/>
              </div>
            </div>

        }


      </Form>
    )
  }
}

export default injectIntl(UserForm)



// WEBPACK FOOTER //
// ./src/components/UserForm.js